/**
 * Resize Behavior Detection Strategy
 */
import { BaseStrategy } from '../strategy.js';
import { inverseSigmoid, sigmoid } from '../math-utils.js';
export class ResizeStrategy extends BaseStrategy {
    constructor() {
        super(...arguments);
        this.name = 'resize';
        this.defaultWeight = 0.02;
        this.events = [];
        this.listener = null;
        this.isActive = false;
        this.lastMousePosition = null;
        this.mouseListener = null;
    }
    start() {
        if (this.isActive)
            return;
        this.isActive = true;
        // Track mouse for resize detection
        this.mouseListener = (e) => {
            const mouseEvent = e;
            this.lastMousePosition = {
                x: mouseEvent.clientX,
                y: mouseEvent.clientY,
            };
        };
        document.addEventListener('mousemove', this.mouseListener, { passive: true });
        // Track resizes
        this.listener = () => {
            var _a, _b;
            const mouseX = (_a = this.lastMousePosition) === null || _a === void 0 ? void 0 : _a.x;
            const mouseY = (_b = this.lastMousePosition) === null || _b === void 0 ? void 0 : _b.y;
            let mouseNearEdge = false;
            if (mouseX !== undefined && mouseY !== undefined) {
                const edgeThreshold = 50;
                mouseNearEdge = (mouseX < edgeThreshold ||
                    mouseX > window.innerWidth - edgeThreshold ||
                    mouseY < edgeThreshold ||
                    mouseY > window.innerHeight - edgeThreshold);
            }
            this.events.push({
                width: window.innerWidth,
                height: window.innerHeight,
                mouseX,
                mouseY,
                mouseNearEdge,
                timestamp: Date.now(),
            });
        };
        window.addEventListener('resize', this.listener);
    }
    stop() {
        if (!this.isActive)
            return;
        this.isActive = false;
        if (this.listener) {
            window.removeEventListener('resize', this.listener);
            this.listener = null;
        }
        if (this.mouseListener) {
            document.removeEventListener('mousemove', this.mouseListener);
            this.mouseListener = null;
        }
    }
    reset() {
        this.events = [];
    }
    score() {
        if (this.events.length === 0)
            return undefined;
        let score = 0;
        let factors = 0;
        // Frequency
        score += inverseSigmoid(this.events.length, 5, 0.5);
        factors++;
        // Mouse near edge
        const withMouse = this.events.filter(e => e.mouseX !== undefined);
        if (withMouse.length > 0) {
            const nearEdge = withMouse.filter(e => e.mouseNearEdge).length;
            score += sigmoid(nearEdge / withMouse.length, 0.5, 8);
            factors++;
        }
        return factors > 0 ? score / factors : undefined;
    }
    getDebugInfo() {
        return {
            eventCount: this.events.length,
            withMouseData: this.events.filter(e => e.mouseX !== undefined).length,
        };
    }
}
